import { useSelector } from 'react-redux';
import React from 'react';
import PropTypes from 'prop-types';
import { Redirect } from 'react-router';

function AuthGuard(props) {
  const rolesArray = Object.values(props.roles);
  const account = useSelector((state) => state.account);
  if (!account.user) {
    return <Redirect to="/login" />;
  }

  if (!rolesArray.includes(account.user.role)) {
    return <Redirect to="/login" />;
  }
  return props.children;
}

AuthGuard.propTypes = {
  children: PropTypes.node.isRequired,
};

export default AuthGuard;
